// config.js
const ENV = process.env.REACT_APP_STAGE || 'TEST'; // 'test' or 'prod'
console.log('Using ENV:', ENV);

const RUN_LOCAL_STAGE = true;

const BCK_API_LOCAL = false;
const BCK_BOOKKEEPING_API_LOCAL = true;
const BCK_AVA_API_LOCAL = false;

const getLocalConfig = () => {
  const localStaticValues = {
    USER_POOL_ID: 'us-east-2_iqATlvpgN',
    APP_CLIENT_ID: '2ku43pgie8p34rklbg666gd9md',

    GA_ID: 'G-J7V5P484KH'
  }
  if (!RUN_LOCAL_STAGE) {
    return ({
      ...localStaticValues,
      BCK_API_V2_URL: BCK_API_LOCAL ? 'http://localhost:6969/test/' : 'https://nii9lmm7t1.execute-api.us-east-2.amazonaws.com/test/',
      BCK_BOOKKEEPING_API_URL: BCK_BOOKKEEPING_API_LOCAL ? 'http://localhost:7777/test/' : 'https://8vw9c480rl.execute-api.us-east-2.amazonaws.com/test/',
      BCK_AVA_V1_URL: BCK_AVA_API_LOCAL ? 'http://localhost:8008/test/' : 'https://vmkk99u462.execute-api.us-east-2.amazonaws.com/test/',
    })
  } else {
    return ({
      ...localStaticValues,
      BCK_API_V2_URL: BCK_API_LOCAL ? 'http://localhost:6969/stage/' : 'https://o7252zw2wj.execute-api.us-east-2.amazonaws.com/stage/',
      BCK_BOOKKEEPING_API_URL: BCK_BOOKKEEPING_API_LOCAL ? 'http://localhost:7777/stage/' : 'https://gw5i3iqbec.execute-api.us-east-2.amazonaws.com/stage/',
      BCK_AVA_V1_URL: BCK_AVA_API_LOCAL ? 'http://localhost:8008/stage/' : 'https://7ipct4ad5e.execute-api.us-east-2.amazonaws.com/stage/',
    })
  }
}

const config = {
  LOCAL: getLocalConfig(),
  TEST: {
    BCK_API_V2_URL: 'https://nii9lmm7t1.execute-api.us-east-2.amazonaws.com/test/',
    BCK_BOOKKEEPING_API_URL: 'https://8vw9c480rl.execute-api.us-east-2.amazonaws.com/test/',
    BCK_AVA_V1_URL: 'https://vmkk99u462.execute-api.us-east-2.amazonaws.com/test/',

    USER_POOL_ID: 'us-east-2_iqATlvpgN',
    APP_CLIENT_ID: '2ku43pgie8p34rklbg666gd9md',

    GA_ID: 'G-J7V5P484KH'
  },
  STAGE: {
    BCK_API_V2_URL: 'https://o7252zw2wj.execute-api.us-east-2.amazonaws.com/stage/',
    BCK_BOOKKEEPING_API_URL: 'https://gw5i3iqbec.execute-api.us-east-2.amazonaws.com/stage/',
    BCK_AVA_V1_URL: 'https://7ipct4ad5e.execute-api.us-east-2.amazonaws.com/stage/',

    USER_POOL_ID: "us-east-2_ssrPIwZPU",
    APP_CLIENT_ID: "c2v3b6it63tnchkmh52ltttfp",
    GA_ID: 'G-J7V5P484KH'
  },
  PROD: {
    BCK_API_V2_URL: 'https://ehmejvr6bg.execute-api.us-east-2.amazonaws.com/prod/',
    BCK_BOOKKEEPING_API_URL: 'https://xkahxzm19i.execute-api.us-east-2.amazonaws.com/prod/',
    BCK_AVA_V1_URL: 'https://8xw84pveh5.execute-api.us-east-2.amazonaws.com/prod/',

    USER_POOL_ID: "us-east-2_ssrPIwZPU",
    APP_CLIENT_ID: "c2v3b6it63tnchkmh52ltttfp",

    GA_ID: 'G-76JTGL68S2'
  },
};

export const getEnv = () => ENV;
export const getLocalEnv = () => RUN_LOCAL_STAGE ? 'STAGE' : 'DEV';
export const getConfig = () => config[ENV];